import React from 'react'
// css file import
import "./searchresult.css"
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder'
// the star icon import
import StarIcon from '@material-ui/icons/Star'
function SearchResult({//the props for the main search page 
    img,
    location,
    title,
    description,
    star,
    price,
    total,
}) {
    return (
        <div className="searhResult">
            <img src={img} alt="" />
            <FavoriteBorderIcon
                className="searchresult__heart" />

            <div className="searchresult__info">
                <div className="searchresult__infotop">
                    <p>{location}</p>
                    <h3>{title}</h3>
                    <p>______</p>
                    <p>{description}</p>

                </div>


                <div className="searchresult__infobottom">
                    <div className="searhresult__stars">{/*this is the complete stars class*/}
                    <br />  
                    <br />
                        <StarIcon className="searchresult__star" />{/*this is the singal stars class*/}
                        <br />
                            <strong>{star}</strong>
                        

                    </div>
                    <div className="searchresultprice">
                        <br />
                        <h2>{price}</h2>
                        <p>{total}</p>
                    </div>

                </div>


            </div>

        </div>
    )
}

export default SearchResult
